import { ButtonColor } from '../enums/button-color.enum';

export const ButtonColorClass = {
    [ButtonColor.NONE]: '',
    [ButtonColor.PRIMARY]: 'mat-primary',
    [ButtonColor.ACCENT]: 'mat-accent',
    [ButtonColor.WARN]: 'mat-warn',
};
